module.exports = __webpack_public_path__ + "img/kelso-brown.0cf22b1.webp";